import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'

import compose from 'recompose/compose'

import View from './OvertimeRecordImporter'


const upload = ({ file }) => async () => {
  const url = 'api/route/overtime'
  const response = await fetch(
    url,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: file,
    },
  )

  const text = await response.text()
  if (response.ok) {
    window.alert(text)
  } else {
    window.alert(`ERROR: ${text}`)
  }
}

const OvertimeRecordImporter = compose(
  withState('file', 'setFile', null),
  withHandlers({
    onDropAccepted: ({ setFile }) => files => setFile(files[0]),
    upload,
  }),
)(View)

OvertimeRecordImporter.displayName = 'OvertimeRecordImporter'

export default OvertimeRecordImporter



// WEBPACK FOOTER //
// ./src/components/OvertimeRecordImporter/index.js